/* Carosello video: frecce, un solo video alla volta, avvio in silenzio quando visibile. */
(function () {
  'use strict';
  if (window.__tlVideos) return;
  window.__tlVideos = true;
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(el) {
    var track = el.querySelector('[data-tl-vids-track]');
    if (!track) return;
    var prev = el.querySelector('[data-dir="-1"]');
    var next = el.querySelector('[data-dir="1"]');
    var vids = Array.prototype.slice.call(track.querySelectorAll('video'));
    var auto = el.dataset.autoplay === 'true' && !reduced;

    function step() {
      var card = track.querySelector('.tl-vid');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function updateNav() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
      var hide = max <= 4;
      prev.hidden = hide; next.hidden = hide;
    }
    [prev, next].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        track.scrollBy({ left: step() * parseInt(b.dataset.dir, 10), behavior: reduced ? 'auto' : 'smooth' });
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { updateNav(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();

    function anyPlaying() { return vids.some(function (v) { return !v.paused && !v.ended; }); }
    vids.forEach(function (v) {
      var card = v.closest('.tl-vid');
      v.addEventListener('play', function () {
        vids.forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
        if (card) card.classList.add('is-playing');
      });
      v.addEventListener('pause', function () { if (card) card.classList.remove('is-playing'); });
    });

    if ('IntersectionObserver' in window && vids.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.intersectionRatio >= 0.6) {
            if (auto && !anyPlaying()) {
              v.muted = true;
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6] });
      vids.forEach(function (v) { io.observe(v); });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-tl-vids]:not([data-tl-ready])').forEach(function (el) {
      el.dataset.tlReady = '1';
      init(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
